import useErrors from '../../error/useErrors';
import { useErrorStore } from '../../error';
import { serviceErrorSerializer } from './serviceErrors';
import { inputValidator } from './inputErrors';

/*
 * This serve as a wrapper for useErrors hook to configure the result of useErrors hook.
 */
function useBillingErrors (props = {}) {
    const {
        input,
    } = props;

    const store = useErrorStore();

    const {
        errors,
        hasError,
        hasInputError,
        isGenericError,
    } = useErrors({
        useTouched: true,
        hook: 'useBillingErrors',
        input: input,
        inputValidator,
        serviceErrorSerializer,
        errorObservables: [
            store.observed.errors.createSubscription,
            store.observed.errors.updateSubscription,
        ],
    });

    /*
     * This response will be consumed by the UI components...
     */
    return {
        errors,
        hasError,
        hasInputError,
        isGenericError,
    };
}

export default useBillingErrors;
